import { RouteComponentProps } from 'react-router-dom';
import { fetchPetInitInfo } from './aboutApi/petInitApi';
// type helper
export type MyAwaited<T> = T extends Promise<infer U> ? U : T;
export type PetInitInfo = MyAwaited<ReturnType<typeof fetchPetInitInfo>>;
interface IRouteMatchParams {
  uuid: string
}

export interface IProps extends RouteComponentProps<IRouteMatchParams> { }

export const STEP = {
  /** 我要試算 */
  calcBill: 1,
  /** 填寫資料 */
  infoFill: 2,
  /** 告知事項 */
  infoCheck: 3,
  /** 資料預覽 */
  preview: 4,
  // /** 驗證 OTP 驗證碼 */
  VerifyOTP: 5,
  /** 確認付款 */
  payment: 6,
  /** 成功投保 */
  success: 7,
  null: null
} as const;
export type STEP = typeof STEP[keyof typeof STEP];

export const PetType = {
  dog: '0',
  cat: '1'
} as const;

export const Gender = {
  male: '1',
  female: '0'
} as const;

export const styles: { [key: string]: React.CSSProperties } = {
  inline: {
    display: 'none'
  }
};

export const CALC_PLANS = ['1', '2', '3'];

export interface question {
  SN: number;
  KYC_ID: string;
  KYC_ORDER: number;
  KYC_SUBJECT: string;
  KYC_OPTIONS: Array<object>;
  KYC_TYPE: string;
}

export interface FormField {
  fundSource: Array<question>;
  ask: Array<question>;
  inform: Array<question>;
}

export const steril = {
  No: '0',
  Yes: '1'
};

export interface evalObject {
  QUOTE_OID: string;
  DPLY_START_DATE: string;
  DPLY_END_DATE: string;
  PLAN_ID: string;
  PET_VAR_TYPE: string;
  PET_STERIL: string;
  PET_POLICY_AGE: string;
  AMOUNT1: number;
  AMOUNT2: number;
  AMOUNT3: number;
  AMOUNT4: number;
  AMOUNT5: number;
  AMOUNT6: number;
  AMOUNT7: number;
  AMOUNT8: number;
  AMOUNT9: number;
  AMOUNT10: number;
  AMOUNT11: number;
  AMOUNT12: number;
  PREMIUM: number;
  DEDUCTIBLE1: string;
  DEDUCTIBLE2: string;
  DEDUCTIBLE3: string;
  DEDUCTIBLE4: number;
  DEDUCTIBLE5: number;
  DEDUCTIBLE6: number;
  DEDUCTIBLE7: number;
  DEDUCTIBLE8: number;
  DEDUCTIBLE9: number;
  FREQUENCY1: number;
  FREQUENCY2: number;
  FREQUENCY3: number;
};

export interface evalTableRow {
  title: string;
  value: Array<number | string>;
}
